import { ChangeEvent } from 'react'
import {
  Typography,
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material'
import { PLAN_ACCESS_TYPE } from 'Common/Constants/Constants'

interface PlanAccessSelectorProps {
  value: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
}

export const PlanAccessSelector = ({
  value,
  onChange,
  disabled = false,
}: PlanAccessSelectorProps) => {
  return (
    <Box
      display={'flex'}
      flexDirection="row"
      marginTop={2}
      justifyContent="space-between"
    >
      <Box display="flex" alignItems="center" width="20%">
        <Typography>Plan access</Typography>
      </Box>
      <Box marginLeft={3}>
        <FormControl disabled={disabled}>
          <RadioGroup
            aria-labelledby="plan-access-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={value}
            onChange={onChange}
            row
          >
            <FormControlLabel
              value={PLAN_ACCESS_TYPE.PRIVATE}
              control={<Radio />}
              label="Private"
            />
            <FormControlLabel
              value={PLAN_ACCESS_TYPE.PUBLIC}
              control={<Radio />}
              label="Public"
            />
          </RadioGroup>
        </FormControl>
      </Box>
      <Box display="flex" alignItems="center" width="20%" paddingLeft={1}></Box>
    </Box>
  )
}
